import React from 'react';
import './App.css'; // Custom styles
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation'; // Terminal-style navigation
import Profile from './components/Profile';
import Resume from './components/Resume';
import Portfolio from './components/Portfolio';
import Certifications from './components/Certifications';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './components/Header';
import Home from './components/Home';
import PageTitle from './components/PageTitle';
import Footer from './components/Footer';
const App = () => {
  return (
    <Router>
      <div className="app">
        <Container className="text-light mt-md-5">
          <Row>
            <Header />
            <Col md={10} className='order-2 order-md-1'>
              {/* Page Routes */}
              <div className="container mb-5">
                 {/* Main Title */}
                 <PageTitle />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/resume" element={<Resume />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="/certifications" element={<Certifications />} />
                </Routes>
              </div>

            </Col>
            <Col md={2} className='order-1 order-md-2'>
              <Navigation />
            </Col>
          </Row>

        </Container>
        <Footer />
        {/* Navigation Menu */}
      </div>
    </Router>
  );
};

export default App;
